// Sentimento do insight (>0 positivo, <0 negativo, 0 neutro, null/undefined sem
// dado) como cor da paleta do MUI.
export const getSentimentColor = (sentiment) => {
  if (sentiment === null || sentiment === undefined) return null;
  if (sentiment > 0) return 'success';
  if (sentiment < 0) return 'error';
  return 'warning';
};

// sx de um Chip tingido na cor do sentimento (sem dado: tons neutros).
export const sentimentChipSx = (sentiment) => (theme) => {
  const palette = (theme.vars || theme).palette;
  const key = getSentimentColor(sentiment);
  const color = key ? palette[key].main : palette.text.disabled;
  return {
    bgcolor: key ? theme.alpha(palette[key].main, 0.08) : palette.action.hover,
    color,
    '& .MuiChip-icon': { color },
  };
};
